// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { ILogger } from "@lib/logging/ILogger";
import { LogLevel } from "@lib/logging/LogLevel";

/**
 * Provides methods for logging to multiple loggers at once.
 */
export class RootLogger implements ILogger
{
  private readonly loggers: Set<ILogger> = new Set();

  enabled = true;
  logLevel: LogLevel = LogLevel.All;

  constructor(loggers: ILogger[])
  {
    for (const logger of loggers)
      this.loggers.add(logger);
  }

  addLogger(logger: ILogger)
  {
    this.loggers.add(logger);
  }

  removeLogger(logger: ILogger)
  {
    this.loggers.delete(logger);
  }

  log(logLevel: LogLevel, format: string, args: any[])
  {
    if (!this.enabled || logLevel < this.logLevel)
      return;

    for (const logger of this.loggers)
      logger.log(logLevel, format, args);
  }
}